import { render, staticRenderFns } from "./TemplateDialog.vue?vue&type=template&id=1953386c"
import script from "./TemplateDialog.vue?vue&type=script&lang=js"
export * from "./TemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplateDialog.vue?vue&type=style&index=0&id=1953386c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports